export enum ActionType {
  GET_AUTOCOMPLETE_RESULTS = "GET_AUTOCOMPLETE_RESULTS"
}

interface IGetAutocompleteResults {
  type: ActionType.GET_AUTOCOMPLETE_RESULTS,
  predictions: any[]
}

export type Action = IGetAutocompleteResults;
